import { api } from './config';
import { ApiResponse } from '../types';

export interface McpOAuthClientView {
  id: number;
  client_id: string;
  has_secret: boolean;
  name: string;
  redirect_uri: string;
  scopes: string;
  is_active: boolean;
  mcp_server_url: string;
  /** discovery 미지원 client (Gemini Enterprise) 수동 입력용. */
  authorization_endpoint: string;
  token_endpoint: string;
  created_at: string;
  updated_at: string;
}

export interface McpOAuthClientCreateRequest {
  clientId: string;
  name?: string;
  redirectUri: string;
  scopes?: string;
  /** 선택. 비워두면 backend 가 자동 생성 (32-byte random). */
  clientSecret?: string;
}

export interface McpOAuthClientCreateResponse {
  client: McpOAuthClientView;
  client_secret: string;
  mcp_server_url: string;
  warning: string;
}

export interface McpOAuthClientRevealResponse {
  id: number;
  client_secret: string | null;
  available: boolean;
}

export const mcpOAuthClientsApi = {
  list: () => api.get<ApiResponse<McpOAuthClientView[]>>('/admin/mcp/oauth-clients'),

  /**
   * Backend Jackson 전역 SNAKE_CASE 설정 — 요청 body 도 snake_case 키로 보내야 함.
   * Frontend 내부 타입은 camelCase 유지하고 여기서 변환.
   */
  create: (data: McpOAuthClientCreateRequest) =>
    api.post<ApiResponse<McpOAuthClientCreateResponse>>('/admin/mcp/oauth-clients', {
      client_id: data.clientId,
      name: data.name,
      redirect_uri: data.redirectUri,
      scopes: data.scopes,
      client_secret: data.clientSecret,
    }),

  toggle: (id: number) =>
    api.post<ApiResponse<McpOAuthClientView>>(`/admin/mcp/oauth-clients/${id}/toggle`),

  remove: (id: number) =>
    api.delete<ApiResponse<void>>(`/admin/mcp/oauth-clients/${id}`),

  reveal: (id: number) =>
    api.get<ApiResponse<McpOAuthClientRevealResponse>>(`/admin/mcp/oauth-clients/${id}/reveal`),
};
